"use client";

import { useI18n } from "@wojo/localization";
import { Card, Button } from "@wojo/ui";
import cn from "clsx";
import React from "react";
import styles from "./BaseLoyaltyOverviewCard.module.scss";
import Link from "next/link";

type SeeDetailsLink = {
    accessibleText: string;
    url: string;
};

export type BaseLoyaltyOverviewCardProps = {
    badge?: React.ReactNode;
    content: React.ReactNode;
    seeDetailsLink?: SeeDetailsLink;
    footer?: React.ReactNode;
};

export const BaseLoyaltyOverviewCard: React.FC<
    BaseLoyaltyOverviewCardProps
> = ({ badge, content, seeDetailsLink, footer }) => {
    const loyaltyI18n = useI18n("account").account.loyalty;

    return (
        <Card className={styles.card}>
            <div
                className={cn(styles.grid, {
                    [styles["grid--with-badge"]]: badge,
                    [styles["grid--with-see-details"]]: seeDetailsLink,
                })}
            >
                <div className={styles["content-wrapper"]}>{content}</div>
                <div className={styles["mobile-right-wrapper"]}>
                    {badge && (
                        <div className={styles["badge-wrapper"]}>{badge}</div>
                    )}
                    {seeDetailsLink && (
                        <div className={styles["see-details-wrapper"]}>
                            <Button
                                variant="quiet"
                                href={seeDetailsLink.url}
                                tag={Link}
                            >
                                <span
                                    aria-hidden={
                                        !!seeDetailsLink.accessibleText
                                    }
                                >
                                    {loyaltyI18n.baseLoyaltyCard.seeDetails.l()}
                                </span>
                                {seeDetailsLink.accessibleText && (
                                    <span className="visually-hidden">
                                        {seeDetailsLink.accessibleText}
                                    </span>
                                )}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            {footer && (
                <>
                    <div className={styles.separator} />
                    {footer}
                </>
            )}
        </Card>
    );
};
